export const SERVICES = [
  {
    slug: "full-day-tour",
    title: "Full Day Tour — Sydney to the Blue Mountains",
    desc: "Picked up in Sydney and driven into the heart of the Blue Mountains — multiple guided walks with Daniel, a 90-minute lunch break in Leura, then home to Sydney.",
    includes: [
      "Sydney pickup & return",
      "Multiple guided walks",
      "90-minute lunch break in Leura",
    ],
    price: "$550 per person · 12 hours · GST inclusive",
  },
  {
    slug: "private-transfers",
    title: "Private Transfers",
    desc: "Door-to-door across the Blue Mountains and Greater Sydney — stations, hotels, lookouts and everywhere in between.",
  },
  {
    slug: "airport-transfers",
    title: "Airport Transfers",
    desc: "Sydney Airport to the Mountains and back, with live flight tracking and a meet-and-greet at arrivals.",
  },
  {
    slug: "bespoke-tours",
    title: "Bespoke Tours",
    desc: "Your itinerary, your pace — lookouts, villages, gardens and wineries woven into a private day out.",
  },
  {
    slug: "group-transfers",
    title: "Group Transfers",
    desc: "Seven seats plus luggage — family groups, walking clubs and conference parties moved together, comfortably.",
  },
  {
    slug: "wedding-transfers",
    title: "Wedding Transfers",
    desc: "Calm, polished arrivals for the wedding party and guests — timed to the minute, styled to the day.",
  },
  {
    slug: "megalong-dryridge",
    title: "Megalong Valley & Dryridge Estate",
    desc: "Transfers and tours into the Megalong Valley — cellar doors, escarpment views and Dryridge Estate done properly.",
  },
  {
    slug: "jenolan-caves",
    title: "Jenolan Caves Transfers",
    desc: "The winding road to the world's oldest open caves, driven by someone who knows every bend.",
  },
  {
    slug: "lost-city",
    title: "Lost City Transfers",
    desc: "Pagoda rock formations and quiet lookouts — the Gardens of Stone's hidden city, without the hike in.",
  },
  {
    slug: "glow-worm-tunnel",
    title: "Glow Worm Tunnel Transfers",
    desc: "Newnes Plateau's famous tunnel of light — transfers timed for the best glow, torches optional.",
  },
];
